import React from 'react';
import { useLocation } from 'react-router-dom';
import ViewProduct from '../components/ViewProduct';

const ViewProductPage = ({
  cart = [],
  setCart,
  isLoggedIn,
  user,
  onLoginSuccess,
  onRemoveItem,
  guestCartId,
  toggleCartDropdown,
  showCartDropdown,
  calculateTotal,
  resetSelectedCategory
}) => {
  const location = useLocation();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  return (
    <div className="app-container">
      <div className="home-content-component">
        <ViewProduct
          product={location.state?.product}
          cart={cart}
          setCart={setCart}
          isLoggedIn={isLoggedIn}
          user={user}
        />
      </div>
    </div>
  );
};

export default ViewProductPage;